import { IconButton, Stack } from '@mui/material';
import { forwardRef, useEffect, useRef } from 'react';
// import Lightbox from 'yet-another-react-lightbox';
// import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import PropTypes from 'prop-types';
import {
  // Maximize,
  Rotate90DegreesCcw,
  Save
} from '../../../node_modules/@mui/icons-material/index';
// import { useOpen } from 'hooks/useOpen';
import StyledVisualizer from './Visualizer.style';

export const Visualizer = forwardRef(
  ({ downloadURL, height, id, isLoading, setInitPosition, width, title }, canvasContainerRef) => {
    const linkRef = useRef(null);
    // const theme = useTheme();
    // const [open, onOpen, onClose] = useOpen();

    useEffect(() => {
      const link = linkRef.current;

      if (!isLoading && link && downloadURL) {
        link.href = downloadURL;
      }
    }, [isLoading, linkRef.current, downloadURL]);

    return (
      <>
        <StyledVisualizer.Wrapper>
          <StyledVisualizer.HeaderWrapper>
            {title}

            {/* {isLoading ? (
              <LoaderIcon stroke={theme.palette.grey[300]} />
            ) : ( */}
            <Stack alignItems="center" direction="row" spacing={2}>
              {setInitPosition && (
                <IconButton onClick={setInitPosition}>
                  <Rotate90DegreesCcw height={24} width={24} />
                </IconButton>
              )}
              <StyledVisualizer.Link download="scheme.jpg" href="#" ref={linkRef}>
                <Save />
              </StyledVisualizer.Link>
              {/* <IconButton onClick={onOpen}>
                <Maximize />
              </IconButton> */}
            </Stack>
            {/* )} */}
          </StyledVisualizer.HeaderWrapper>
          <StyledVisualizer.CanvasWrapper
            id={id}
            height={height}
            ref={canvasContainerRef}
            width={width}
          />
        </StyledVisualizer.Wrapper>
        {/* <Lightbox
          close={onClose}
          index={0}
          open={open}
          plugins={[Zoom]}
          carousel={{
            finite: true
          }}
          zoom={{
            maxZoomPixelRatio: 3, // Example configuration
            zoomInMultiplier: 1.2, // Controls zoom speed
            scrollToZoom: true // Enables zooming with scroll
          }}
          slides={[{ src: downloadURL || '' }]}
        /> */}
      </>
    );
  }
);

Visualizer.propTypes = {
  downloadURL: PropTypes.string,
  height: PropTypes.number,
  id: PropTypes.string,
  isLoading: PropTypes.bool,
  setInitPosition: PropTypes.func,
  title: PropTypes.string,
  width: PropTypes.number
};
